import {
    SAVE_TOKEN,
    SAVE_PRESIGNED_URL,
    SAVE_REQUEST_STATE,
    UPDATE_SHOW_APP_REQUIREMENT,
    EXECUTE_DIALOG_ACTION
} from './actions';

export const getToken = () => {
    let token = ''
    let url = window.location.toString();
    let queryParams = url.split("?")[1]
    if (queryParams) {
        token = queryParams.split("=")[1]
        localStorage.setItem('token', token)
    } else {
        token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
    }
    return token
}

export const initialState = {
    token: getToken(),
    presignedURL: {},
    requestState: {},
    showAppRequirement: false,
    dialogAction: {}
};

const sharedReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_TOKEN:
            return {
                ...state,
                token: action.token
            }
        case SAVE_PRESIGNED_URL:
            return {
                ...state,
                presignedURL: action.presignedURL
            }
        case SAVE_REQUEST_STATE:
            return {
                ...state,
                requestState: action.requestState
            }
        case UPDATE_SHOW_APP_REQUIREMENT:
            return {
                ...state,
                showAppRequirement: action.show
            }
        case EXECUTE_DIALOG_ACTION:
            return {
                ...state,
                dialogAction: action.data
            }
        default: return state
    }
}

export default sharedReducer;